import { ContractorType } from "../dto/Contractors/ContractorDto";

import i18n from "../i18n";
import exhaustiveCheck from "./exhaustiveCheck";

export default (type: ContractorType) => {
  switch (type) {
    case "CLIENT":
      return i18n.t("client");
    case "CARRIER":
      return i18n.t("carrier");
    case "OTHER":
      return i18n.t("other");
    case "SUPPLIER":
      return i18n.t("supplier");
    default:
      return exhaustiveCheck(type);
  }
};
